import { SuiteManifest } from './manifest';
import dataManifest from './data';
import salesManifest from './sales';
import coreManifest from './core';
import crmManifest from './crm';
import financeManifest from './finance';
import operationsManifest from './operations';
import projectsManifest from './projects';
import peopleManifest from './people';
import supportManifest from './support';
import marketingManifest from './marketing';
import helpdeskManifest from './helpdesk';
import inventoryManifest from './inventory';
import deliveryManifest from './delivery';
import settingsManifest from './settings';
import webbuilderManifest from './webbuilder';

export const allSuites: SuiteManifest[] = [
  coreManifest,
  dataManifest,
  salesManifest,
  crmManifest,
  financeManifest,
  operationsManifest,
  projectsManifest,
  peopleManifest,
  supportManifest,
  marketingManifest,
  helpdeskManifest,
  inventoryManifest,
  deliveryManifest,
  settingsManifest,
  webbuilderManifest,
];

export function getSuiteById(id: string): SuiteManifest | undefined {
  return allSuites.find((s) => s.id === id);
}

export function getAllSuites(): SuiteManifest[] {
  return allSuites;
}
